import { ArrowRight } from "@phosphor-icons/react/dist/ssr";

import { Button } from "@/src/components/ui/Button";
import { Tag } from "@/src/components/ui/Tag";
import { Text } from "@/src/components/ui/Typography";
import { cn } from "@/src/lib/utils";

import type { ExpertiseItem } from "./data";

interface ExpertiseMobileRowProps {
  item: ExpertiseItem;
  active: boolean;
  onSelect: () => void;
}

export function ExpertiseMobileRow({
  item,
  active,
  onSelect,
}: ExpertiseMobileRowProps) {
  return (
    <div className="border-b border-neutral-200 py-6 first:pt-0 last:border-b-0">
      <button
        type="button"
        onClick={onSelect}
        aria-expanded={active}
        className="flex items-baseline gap-4 text-left"
      >
        <Text
          as="span"
          size="labelMD"
          className={cn(
            "transition-colors duration-300",
            active ? "text-neutral-700" : "text-neutral-400",
          )}
        >
          {item.number}
        </Text>

        <Text
          as="span"
          size="titleMD"
          className={cn(
            "transition-colors duration-300",
            active ? "text-neutral-700" : "text-neutral-400",
          )}
        >
          {item.title}
        </Text>
      </button>

      <div
        className={cn(
          "grid overflow-hidden transition-all duration-500 ease-[cubic-bezier(.22,1,.36,1)]",
          active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
        )}
      >
        <div className="min-h-0 overflow-hidden pt-4">
          <Text size="bodySM" className="max-w-100 text-neutral-600">
            {item.description}
          </Text>

          <div className="mt-4 flex flex-wrap gap-3">
            {item.tags.map((tag) => (
              <Tag key={tag}>{tag}</Tag>
            ))}
          </div>

          <Button
            href={item.href}
            variant="link"
            className="mt-8 pl-0"
          >
            Learn More
          </Button>
        </div>
      </div>
    </div>
  );
}
